import React, { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Layout from 'web/components/Layout';
import Spinner from 'web/components/Spinner';
import Breadcrumb from 'web/components/Breadcrumb';
import AlertModal from 'web/components/AlertModal';
import { getPostInitialValues, getValidateSchema, } from 'web/components/utils/checkoutUtilsV2';
import { getBuyerNeedCheckoutDataApi, getCheckoutPageDetailsBuyerInvApi, getCheckoutPageDetailsSellerInvApi, getCheckoutPageDetailsSellerPickupOrderApi, getCheckoutPageDetailsSellerDelReqOrderApi } from 'redux/actions/checkout';
import { fetchLanguageContentNew } from 'redux/actions/language';
import BuyerNeed from './BuyerNeed';
import BuyerInventory from './BuyerInventory'
import SellerInventory from './SellerInventory'
import SellerPickupOrder from './SellerPickupOrder'
import SellerDeliveryOrder from './SellerDeliveryOrder'
import { Container, Wrapper, Section } from './checkOutStyle'

const CheckOut = (props) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const token = localStorage.getItem('token');
  const [checkoutPageData, setCheckoutPageData] = useState()
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);

  const urlObject = useSelector((state) => state.urlParameters.checkout);

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [modalCallBack, setModalCallBack] = useState();
  const toggleModal = () => setModal(!modal);

  // set page locale values
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()
  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    window.scrollTo(0, 0)
    let offerCheckoutId = urlObject?.id;
    if (urlObject?.type === 'buyerNeedCheckout') getCheckoutPageDetailsBuyerNeed()
    else if (urlObject?.type?.includes('buyerInvCheckout')) getCheckoutPageDetailsBuyerOfr()
    else if (urlObject?.type?.includes('sellerInvCheckout')) getCheckoutPageDetailsSellerOfr(offerCheckoutId)
    else if (urlObject?.type?.includes('sellerPickupOrderCheckout')) getCheckoutPageDetailsSellerPickupOrder()
    else if (urlObject?.type?.includes('sellerDeliveryRequestOrderCheckout')) getCheckoutPageDetailsSellerDelReqOrder()
  }, [urlObject]);

  const [searchParamCheckoutOfferId, setSearchParamCheckoutOfferId] = useState('')
  const [searchParamPostType, setSearchParamPostType] = useState('')
  const [searchParamSelectedPostType, setSearchParamSelectedPostType] = useState('')

  // Get the URL search parameters
  const searchParams = new URLSearchParams(window.location.search);
  useEffect(() => {

    const checkoutOfferId = searchParams.get('id');
    const postType = searchParams.get('postType');
    const selectedPostType = searchParams.get('selectedPostType');

    setSearchParamCheckoutOfferId(checkoutOfferId)
    setSearchParamPostType(postType)
    setSearchParamSelectedPostType(selectedPostType)

    // use the parameters as needed
    if (postType === "PostInventory" && selectedPostType === "buynow") {
      getCheckoutPageDetailsSellerOfr(checkoutOfferId)
    }

    // You can now use these parameters in your component
  }, []);

  const getCheckoutPageDetailsBuyerNeed = async () => {
    let response
    if (urlObject) {
      let data = {
        authId: localStorage.getItem('authId'),
        bidId: urlObject.id
      }
      response = await dispatch(getBuyerNeedCheckoutDataApi(data, token));
    }
    if (response.success) {
      setCheckoutPageData(response.data)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const getCheckoutPageDetailsBuyerOfr = async () => {
    let response
    if (urlObject) {
      let data = {
        authId: localStorage.getItem('authId'),
        invId: urlObject.id
      }
      response = await dispatch(getCheckoutPageDetailsBuyerInvApi(data, token));
    }
    if (response.success) {
      setCheckoutPageData(response.data)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const getCheckoutPageDetailsSellerOfr = async (offerId) => {
    let response
    if (urlObject || searchParams) {
      let data = {
        authId: localStorage.getItem('authId'),
        // offerId: urlObject.id
        offerId: offerId
      }
      response = await dispatch(getCheckoutPageDetailsSellerInvApi(data, token));
    }
    if (response.success) {
      setCheckoutPageData(response.data)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const getCheckoutPageDetailsSellerPickupOrder = async () => {
    let response
    if (urlObject) {
      let data = {
        authId: localStorage.getItem('authId'),
        tenderId: urlObject.id
      }
      response = await dispatch(getCheckoutPageDetailsSellerPickupOrderApi(data, token));
    }
    if (response.success) {
      setCheckoutPageData(response.data)
    } else {
      if (response?.statusCode === 400) {
        setModalCallBack('toManageAccountFromCheckout')
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      } else if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const getCheckoutPageDetailsSellerDelReqOrder = async () => {
    let response
    if (urlObject) {
      let data = {
        authId: localStorage.getItem('authId'),
        tenderId: urlObject.id
      }
      response = await dispatch(getCheckoutPageDetailsSellerDelReqOrderApi(data, token));
    }
    if (response.success) {
      setCheckoutPageData(response.data)
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: '/dashboard',
      eventType: 'Link'
    },
    {
      name: urlObject?.type?.includes('sellerPickupOrderCheckout') ? 'My Pickup orders' :
        urlObject?.type?.includes('sellerDeliveryRequestOrderCheckout') ? 'My Orders' : 'My Posts',
      link: urlObject?.type?.includes('sellerPickupOrderCheckout') ? '/my-pickup-orders' :
        urlObject?.type?.includes('sellerDeliveryRequestOrderCheckout') ? 'my-orders' : 'My Posts',
      eventType: 'Click'
    },
  ]

  return (
    <Layout transparentHeader={false} topBarViewMobile={"hide"}>
      {loaderVisible && <Spinner />}
      <Container>
        <Breadcrumb breadcrumbArr={breadcrumbMapArr} selected={pageLanguageContents?.Breadcrumb[3]?.Checkout} title="" />
        {checkoutPageData &&
          <Formik
            initialValues={getPostInitialValues(checkoutPageData, urlObject)}
            validationSchema={getValidateSchema(checkoutPageData)}
            onSubmit={(values) => { }}>
            {(props) => {
              const { isValid, dirty, values, errors, touched, setFieldValue } = props;
              return (
                <>
                  <Form>
                    <Wrapper>
                      <Section>
                        {loaderVisible && <Spinner />}
                        {urlObject?.type === 'buyerNeedCheckout' &&
                          <BuyerNeed
                            callBackCheckoutFetchApi={getCheckoutPageDetailsBuyerNeed}
                            checkoutPageData={checkoutPageData}
                            props={props} />
                        }
                        {urlObject?.type?.includes('buyerInvCheckout') &&
                          <BuyerInventory
                            callBackCheckoutFetchApi={getCheckoutPageDetailsBuyerOfr}
                            checkoutPageData={checkoutPageData}
                            props={props} />
                        }
                        {(urlObject && urlObject.type?.includes('sellerInvCheckout')) ?
                          <SellerInventory
                            checkoutPageData={checkoutPageData}
                            props={props}
                          />
                          :
                          (searchParams && searchParamPostType === "PostInventory" && searchParamSelectedPostType === "buynow") ?
                            <SellerInventory
                              checkoutPageData={checkoutPageData}
                              props={props}
                              searchParamCheckoutOfferId={searchParamCheckoutOfferId}
                            />
                            : <></>

                        }
                        {urlObject?.type?.includes('sellerPickupOrderCheckout') &&
                          <SellerPickupOrder
                            callBackCheckoutFetchApi={getCheckoutPageDetailsSellerPickupOrder}
                            checkoutPageData={checkoutPageData}
                            props={props} />
                        }
                        {urlObject?.type?.includes('sellerDeliveryRequestOrderCheckout') &&
                          <SellerDeliveryOrder
                            checkoutPageData={checkoutPageData}
                            props={props} />
                        }
                      </Section>
                    </Wrapper>
                  </Form>
                </>
              );
            }}
          </Formik>}
      </Container>

      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
        link={modalLink === '/view-my-offers-on-pallet-inventory' ? "" : modalLink}
        alertType={modalLink === '/view-my-offers-on-pallet-inventory' ? "MyOfferInventoryBids" : (modalCallBack || "")}
        postType={true}
        inventoryCallBackAlert={() => {
          let obj = {
            postType: "PostInventory",
            type: "bidsPalletOffers",
            activePage: 'PostInventory',
            // activeSearch:'Dashboard',
            expanded: 'panel1'
          }
          dispatch({ type: 'BIDS_INVENTORY', payload: obj })
          history.push({ pathname: modalLink, })
        }}
        callBackAlert={() => {
          if (modalCallBack === 'toManageAccountFromCheckout') {
            setModalCallBack()
            localStorage.setItem('redirectionType', 'toProfileSection')
            history.push('./manage-account')
          }
        }}
      />

    </Layout >
  );
};

export default CheckOut;